import { colors } from "@/styles/colors"
import { makeStyles } from "@/utils/makeStyles"

type ContainerStyleProps = {
	variant: "inbox" | "console"
}

const useStyles = (props: ContainerStyleProps) => makeStyles((theme) => {
	const background = props.variant === "inbox"
		? `linear-gradient(180deg, ${colors.beige[50]} 0%, ${colors.purple[50]} 46.63%)`
		: colors.purple[500]

	return {
		drawerInternalContainer: {
			width: "100%",
			height: "100%"
		},
		drawer: {
			width: theme.spacing(30),
			flexShrink: 0,
			whiteSpace: "nowrap"
		},
		drawerOpen: {
			display: "flex",
			flexDirection: "column",
			width: theme.spacing(30),
			height: "100%",
			overflow: "hidden",
			boxSizing: "border-box",
			borderRight: `1px solid ${colors.gray[200]}`,
			background,
			transition: theme.transitions.create("width", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.enteringScreen
			})
		},
		drawerClose: {
			display: "flex",
			flexDirection: "column",
			width: theme.spacing(10.5),
			height: "100%",
			overflow: "hidden",
			overflowX: "hidden",
			boxSizing: "border-box",
			borderRight: `1px solid ${colors.gray[200]}`,
			background,
			transition: theme.transitions.create("width", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen
			})
		}
	}
})(props)

export default useStyles